<!--
 *                   江城子 . 程序员之歌
 * 
 *               十年生死两茫茫，写程序，到天亮。
 *                   千行代码，Bug何处藏。
 *               纵使上线又怎样，朝令改，夕断肠。
 * 
 *               领导每天新想法，天天改，日日忙。
 *                   相顾无言，惟有泪千行。
 *               每晚灯火阑珊处，夜难寐，加班狂。
 * 
 * 
 * @Author: wangping 1683997498@qq.com
 * @Date: 2023-12-20 08:44:41
 * @LastEditors: wangping 1683997498@qq.com
 * @LastEditTime: 2024-04-09 10:58:03
 * @FilePath: \twzc005-1\src\app3.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 -->

<template>
  <div class="content">
    <div class="main">
      <img class="shoushi_bg" src="@/assets/img2/shoushi_bg.png" alt="" />
      <!-- <div class="tips" v-if="!isMobileDevice">注：移动端不支持手势识别功能</div> -->
      <div class="main1">
      
        <div v-show="!isShow">
          <div class="aiAll">
            <!-- <img :src="aiMobile" class="ai" alt="" v-if="!isMobileDevice"/> -->
            <video src="@/assets/video/idel2.webm" class="ai" muted loop playsinline
                webkit-playsinline autoplay ></video>
            <!-- <video class="ai" ref="morenVideo" autoplay muted loop src="@/assets/video/2.webm"></video>
                        <video class="ai" ref="video" :class="videos ? 'ai1' : 'ai2'" id="myVideo" autoplay muted loop
                            @ended="ended">
                            <source class="source" v-for="(item, index) in videoSrcs" :key="index" :src="item">
                        </video> -->
            <div ref="videoBox" class="videoBox">
              <video
                class="ai"
                ref="video"
                playsinline
                webkit-playsinline
                :class="!playVideoTag ? 'video-hide ai1' : 'ai1'"
                muted="true"
                autoplay
                @ended="onEnded('video')"
              ></video>
              <video
                class="ai"
                ref="video1"
                playsinline
                webkit-playsinline
                :class="playVideoTag ? 'video-hide ai1' : 'ai1'"
                muted="true"
                autoplay
                @ended="onEnded('video1')"
              ></video>
            </div>
          </div>
          <div class="recordAll">
            <img
              @click="record"
              class="record"
              src="@/assets/img2/record_icon.png"
              alt=""
            />
          </div>
          <div class="tip">
            {{ !videos ? "使用手势或触摸屏幕" : "正在为您解答中" }}
          </div>
        </div>
        <div class="dialo" v-if="isShow">
          <div class="img_bg">
            <div class="rowy" ref="rowy">
              <template v-for="(item, index) in prompt">
                <div class="left1" v-if="item.role == 'assistant'">
                  <img src="@/assets/img2/avatar_icon.png" alt="" />
                  <div class="left" v-html="item.content"></div>
                </div>

                <div class="right1" v-if="item.role == 'user'">
                  <img src="@/assets/img2/avatar_icon2.png" alt="" />

                  <div class="right">
                    {{ item.content }}
                  </div>
                </div>
              </template>
              <div class="left1" v-if="event == 'add'">
                <img src="@/assets/img2/avatar_icon.png" alt="" />
                <div class="left" v-html="message"></div>
              </div>
              <div class="delLog" @click="clearHistory">
                <img src="@/assets/img2/del_icon.png" alt="" />
                清除记录
              </div>
            </div>
          </div>
        </div>
        <div class="imgs1">
          <div class="imgs" v-show="!isShow">
            <img
              @click="ask"
              id="startBtn"
              class="duihua"
              ref="bottom"
              src="@/assets/img2/duihua.png"
              alt=""
            />
          </div>
          <div class="imgs11" v-show="isShow">
            <img
              class="icon duihua"
              @click="clone"
              src="@/assets/img2/concel.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="maskFlag" v-show="flags">
      <div class="flag">
        <div class="top">
          <div class="p">
            {{ content ? content : "正在聆听，请告诉我您想问的问题" }}
          </div>
          <div class="abs">{{ countdown }}秒</div>
        </div>
        <div class="btns">
          <div class="btn1" @click="cancelBtn">
            <img src="@/assets/img2/cancel_icon.png" alt="" />
            <div>取消</div>
          </div>
          <div class="btn2" id="endBtn" ref="endBtn" @click="confirmBtn">
            <img src="@/assets/img2/confirm_icon.png" alt="" />
            <div>确定</div>
          </div>
        </div>
        <div class="icon">
          <img src="@/assets/img2/yuyin.png" alt="" />
        </div>
      </div>
    </div>
    <div class="watchDog">{{ watchDog }}</div>
  </div>
</template>
<script>
import aiMobile from "@/assets/img2/ai.gif";
import webscoket from "@/minix/webscoket";
import minix from "@/minix/index";
import clickLimitMixin from "@/minix/clickLimitMixin";
import voiceToText from "@/minix/voiceToText";
import {isMobileDevice} from '@/utils'
export default {
  mixins: [webscoket, minix, clickLimitMixin, voiceToText],
  data() {
    return {
      aiMobile: aiMobile,//移动端待机动画
      flag: false,
      isShow: false,
      // eventSource: null,
      message: "",
      content: "",
      signSucc: "",
      prompt: [],
      event: "",
      timer: null,
      loading: true,
      watchDogInit: 180,
      watchDog: 180,
      videoIndex: 0,
      isMobileDevice:false//是否是移动端
    };
  },
  watch: {
    io(newVal, oldVal) {
      let that = this;
      // that.$refs.bottom.click()
      //  if (that.flags) {
      //         return
      //     }
      // console.error('io ing');
      if (//询问
        newVal ==
        '{"sensor": "CAM", "action": "GESTURE", "val": "Bye", "extras": ""}'
      ) {
        console.log(that.scoket, that, "scoket");
        that.$refs.bottom.click();
      } else if (
        newVal ==
        '{"sensor": "CAM", "action": "GESTURE", "val": "0", "extras": ""}'
      ) {
        console.log(that.$refs.endBtn, "that.$refs.endBtn");
        that.$refs.endBtn.click();
      }
    },
  },

  created() {
    this.webscoket();
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });

    document.addEventListener("selectstart", function (e) {
      e.preventDefault();
    });

    //   document.addEventListener('touchstart', function(event) {
    //     event.preventDefault()
    // }, { passive: false })
  },
  mounted() {
    this.isMobileDevice = isMobileDevice() ? true : false

    // this.audioInit()
  },
  methods: {
    
    // touchend() {
    //     this.$refs.video.play()
    // },
    ended() {
      try {
        this.videoIndex++;
        if (this.videoIndex > this.videoSrcs.length - 1) {
          this.videoIndex = 0;
        }
        let videos = this.$refs.video;
        videos.src = this.videoSrcs[this.videoIndex];
        console.log(this.videoIndex, "ds");
        // 播放视频
        videos.play();
      } catch (error) {
        console.log(error, "error");
      }
    },
    clone() {
      this.isShow = false;
    },
    record() {
      this.isShow = true;
      // setTimeout(()=>{
      this.$nextTick(() => {
        // let container = this.$refs.rowy;
        // console.log(container, "container");
        this.$refs.rowy.scrollTop = this.$refs.rowy.scrollHeight;
      });
    },
  },
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  overflow-y: hidden;
  overflow-x: hidden;
}

body,
html {
  height: 100%;
}

.content {
  // font-family: 'sc_regular';
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: calc(100vw * 45 / 1080) calc(100vw * 87.5 / 1080);
  background: url("@/assets/img2/bg_1.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='bg-login.png', sizingMethod='scale');
}

.top {
  margin-top: calc(100vw * 103 / 1080);
  display: flex;
  align-items: flex-start;

  .anquan {
    margin-top: calc(100vw * 16 / 1080);
    width: calc(100vw * 40 / 1080);
    height: calc(100vw * 40 / 1080);
  }

  .ztz {
    width: calc(100vw * 402 / 1080);
    height: calc(100vw * 208 / 1080);
  }
}

.main {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: calc(100vw * 1372 / 1080);
  .shoushi_bg {
      width: calc(100vw * 939 / 1080);
      height: calc(100vw * 190 / 1080);
      position: absolute;
      top: -7%;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 950;
    }
    .tips{
      font-size: 12px;
      position: absolute;
      color: red;
      top: 45px;
      left: 6%;
      z-index: 950;
    }
  .main1 {
    opacity: 1;
    // min-height: calc(100vw * 1372 / 1080);
    height: 72vh;
    // background: linear-gradient(
    //   180deg,
    //   rgba(255, 255, 255, 1) 0%,
    //   rgba(255, 255, 255, 0.5) 100%
    // );
    background-color: #fff;
    // background-color: rgba(252, 255, 252);
    // background: url("@/assets/img2/main_bg.png") no-repeat;
    // clip-path: polygon(96% 0, 100% 3%, 100% 100%, 0 100%, 0 0);
    background-size: 100% 100%;
    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='bg-login.png', sizingMethod='scale');

   

    .aiAll {
      display: flex;
      justify-content: center;

      .ai {
        margin-top: calc(100vw * 127 / 1080);
        // width: calc(100vw * 480 / 1080);
        width: calc(100vw * 850 / 1080);

        height: calc(100vw * 837 / 1080);
      }

      .ai1 {
        position: absolute;
        z-index: 888;
      }

      .ai2 {
        position: absolute;

        // z-index: -1;
      }
    }

    .recordAll {
      display: flex;
      justify-content: flex-end;

      img {
        width: calc(100vw * 165 / 1080);
        height: calc(100vw * 165 / 1080);
      }
    }

    .tip {
      // font-family: 'weiruan';
      font-size: calc(100vw * 36 / 1080);
      line-height: calc(100vw * 49 / 1080);
      color: rgba(0, 0, 0, 1);
      text-align: center;
      vertical-align: top;
    }

    .imgs1 {
      width: 100%;
      position: absolute;
      bottom: calc(100vw * 50 / 1080);
      left: 0;

      .imgs {
        // margin-top: calc(100vw * 21 / 1080);
        position: relative;
        display: flex;
        justify-content: center;

        .logo {
          position: absolute;
          left: calc(100vw * 70 / 1080);
          top: 50%;
          transform: translate(0, -50%);
          width: calc(100vw * 251 / 1080);
          height: calc(100vw * 91 / 1080);
        }

        .duihua {
          width: calc(100vw * 128 / 1080);
          height: calc(100vw * 128 / 1080);
        }
      }

      .imgs11 {
        // margin-top: calc(100vw * 21 / 1080);
        position: relative;
        display: flex;
        justify-content: center;
        // margin-right: calc(100vw * 20 / 1080);

        .logo {
          position: absolute;
          left: calc(100vw * 70 / 1080);
          top: 50%;
          transform: translate(0, -50%);
          width: calc(100vw * 251 / 1080);
          height: calc(100vw * 91 / 1080);
        }

        .duihua {
          width: calc(100vw * 128 / 1080);
          height: calc(100vw * 128 / 1080);
        }
      }
    }
  }
}

.maskFlag {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.8);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  z-index: 999;

  // font-family: 'wangxingban';
  .flag {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;

    .top {
      width: calc(100vw * 1025 / 1080);
      min-height: calc(100vw * 249 / 1080);
      background: url("@/assets/img2/duihua_bg.png") no-repeat;
      background-size: 100% 100%;
      filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='bg-login.png', sizingMethod='scale');
      padding: calc(100vw * 64 / 1080) calc(100vw * 64 / 1080)
        calc(100vw * 80 / 1080) calc(100vw * 68 / 1080);
      font-size: calc(100vw * 20 / 1080);
      color: rgba(255, 255, 255, 1);
      position: relative;

      .p {
        overflow: hidden;
        /*超出内容隐藏*/
        text-overflow: ellipsis;
        /*超出内容为省略号*/
        display: -webkit-box;
        /*内容不换行*/
        -webkit-line-clamp: 3;
        /*超出几行*/
        -webkit-box-orient: vertical;
        /*从上到下垂直排列子元素*/
      }

      .abs {
        position: absolute;
        bottom: calc(100vw * 65 / 1080);
        right: calc(100vw * 135 / 1080);
      }
    }

    .btns {
      margin-top: calc(100vw * 20 / 1080);
      display: flex;
      justify-content: center;
      color: #fff;

      .btn1,
      .btn2 {
        width: calc(100vw * 200 / 1080);
        height: calc(100vw * 80 / 1080);
        text-align: center;
        font-size: calc(100vw * 20 / 1080);
      }
    }

    .icon {
      width: 100%;
      height: 100%;
      bottom: calc(100vw * 65 / 1080);

      img {
        width: 100%;
        height: calc(100vw * 235 / 1080);
      }
    }
  }
}

.dialo {
  position: relative;
  padding: calc(100vw * 172 / 1080) calc(100vw * 41 / 1080)
    calc(100vw * 50 / 1080) calc(100vw * 63 / 1080);

  .img_bg {
    position: relative;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
    background: url("@/assets/img2/show_icon.png") no-repeat;
    background-size: 100% 100%;
    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='bg-login.png', sizingMethod='scale');
    width: calc(100vw * 976 / 1080);
    height: calc(100vw * 996 / 1080);
    padding: calc(100vw * 25 / 1080) calc(100vw * 84 / 1080)
      calc(100vw * 35 / 1080) calc(100vw * 47 / 1080);
    //   >img{

    //   width: 100%;
    //   height: 100%;
    // }
    .rowy {
      overflow-y: scroll;
      height: calc(100vw * 800 / 1080);
    }
  }
}

.duihua1 {
  width: calc(100vw * 131 / 1080);
  height: calc(100vw * 121 / 1080);
}

.abs {
  //   position: relative;
  .icon {
    position: absolute;
    top: calc(100vw * -5 / 1080);
    right: 50%;
    transform: translate(-50%, 0);
    width: calc(100vw * 41 / 1080);
    height: calc(100vw * 41 / 1080);
  }
}

.left1 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: calc(100vw * 10 / 1080);
  flex-direction: column;

  img {
    margin-bottom: calc(100vw * 20 / 1080);
    width: calc(100vw * 80 / 1080);
    height: calc(100vw * 80 / 1080);
  }
}

.left2 {
  border-radius: calc(100vw * 15 / 1080) calc(100vw * 15 / 1080)
    calc(100vw * 15 / 1080) 0;
  opacity: 1;
  border: calc(100vw * 3 / 1080) solid #b89774;
  max-width: 90%;
}

.left {
  max-width: 100%;
  opacity: 1;
  border-radius: calc(100vw * 10 / 1080) 0px calc(100vw * 10 / 1080)
    calc(100vw * 10 / 1080);
  background: linear-gradient(
    180deg,
    rgba(6, 143, 255, 1) 0%,
    rgba(0, 187, 255, 1) 100%
  );
  box-shadow: 0px calc(100vw * 20 / 1080) calc(100vw * 20 / 1080)
    rgba(77, 97, 201, 0.3);
  // padding: calc(100vw * 13 / 1080) calc(100vw * 14 / 1080) calc(100vw * 19 / 1080) calc(100vw * 22 / 1080);
  padding: calc(100vw * 13 / 1080) calc(100vw * 14 / 1080)
    calc(100vw * 19 / 1080) calc(100vw * 50 / 1080);

  min-height: calc(100vw * 86 / 1080);
  font-size: calc(100vw * 33 / 1080);
  overflow: auto;
  color: #412c16;
  line-height: calc(100vw * 53 / 1080);
  margin: calc(100vw * 2 / 1080);
}

.right1 {
  width: 100%;
  display: flex;
  align-items: flex-end;
  margin-bottom: calc(100vw * 10 / 1080);
  flex-direction: column;

  img {
    margin-bottom: calc(100vw * 20 / 1080);
    width: calc(100vw * 80 / 1080);
    height: calc(100vw * 80 / 1080);
  }
}

.right2 {
  border-radius: calc(100vw * 15 / 1080) calc(100vw * 15 / 1080) 0px
    calc(100vw * 15 / 1080);
  opacity: 1;
  border: calc(100vw * 3 / 1080) solid #b89774;
  max-width: 90%;
}

.right {
  display: flex;
  justify-content: flex-end;
  padding: calc(100vw * 16 / 1080) calc(100vw * 25 / 1080)
    calc(100vw * 16 / 1080) calc(100vw * 28 / 1080);

  border-radius: calc(100vw * 10 / 1080) 0px calc(100vw * 10 / 1080)
    calc(100vw * 10 / 1080);
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px calc(100vw * 20 / 1080) calc(100vw * 20 / 1080)
    rgba(77, 97, 201, 0.1);
  opacity: 1;
  min-height: calc(100vw * 86 / 1080);
  font-size: calc(100vw * 33 / 1080);

  color: #412c16;
  line-height: calc(100vw * 53 / 1080);

  margin: calc(100vw * 2 / 1080);
}

.delLog {
  display: flex;
  align-items: center;
  color: rgba(61, 121, 254, 1);
  font-size: calc(100vw * 20 / 1080);
  position: absolute;
  bottom: calc(100vw * 60 / 1080);
  right: calc(100vw * 100 / 1080);
}

// .rowy::-webkit-scrollbar {
//   width: 20px; /* 设置滚动条宽度 */
// }
/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 5px;
  /* 设置滚动条宽度 */
}

// /* 滚动条轨道样式 */
// ::-webkit-scrollbar-track {
//   background-color: #f1f1f1; /* 设置滚动条轨道颜色 */
// }

/* 滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #888;
  /* 设置滚动条滑块颜色 */
  border-radius: 5px;
  /* 设置滚动条滑块圆角 */
}

.lodding {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .icon {
    position: relative;
  }
}

.loddingText {
  position: relative;
  top: calc(100vw * 150 / 1080);
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 12px;
}

// /* 鼠标悬停在滚动条上时的样式 */
// ::-webkit-scrollbar-thumb:hover {
//   background-color: #555; /* 设置鼠标悬停时的滚动条滑块颜色 */
// }

// /* 滚动条按钮样式（仅部分浏览器支持） */
// ::-webkit-scrollbar-button {
//   background-color: #ccc; /* 设置滚动条按钮颜色 */
// }
</style>

<style>
.el-loading-mask {
  background-color: transparent !important;
}

.watchDog {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 12px;
  transform: scale(0.4);
  color: #ccc;
}

.rightMB {
  z-index: 900;
  position: absolute;
  top: 0;
  right: calc(100vw * 110 / 1080);
  content: "";
  background-color: #fff;
  width: calc(100vw * 60 / 1080);
  margin-top: calc(100vw * 127 / 1080);
  height: calc(100vw * 837 / 1080);
}

.video-hide {
  position: absolute;
  top: -10000px;
  left: -10000px;
}

.videoBox {
  position: absolute;
  z-index: -1;
  width: calc(100vw * 850 / 1080);

  height: calc(100vw * 960 / 1080);
}
</style>
